export default [
  // { value: "FIFO", label: "FIFO" },
  { value: "LIFO", label: "LIFO" },
  // { value: "میانگین موزون", label: "میانگین موزون" },
];
